// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"107":"pages","391":"shopify","445":"journal","523":"shop"}[chunkId] + "." + {"107":"83111f07","391":"4f09f4a8","445":"91866983","523":"6f2bdbaf"}[chunkId] + ".js";
};